'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	AccountPageController = require('../models/account-page-controller'),
	AjaxPromise = require('../models/ajax-promise'),
	authenticationAWSStart = require('../features/authentication/authentication-aws-start'),
	cognitoStart = require('../features/cognito/cognito-start'),
	getStorage = require('../models/get-storage'),
	GoldAWSApi = require('../models/gold-aws-api'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	S3Api = require('../models/s3-api'),
	pageActionsStart = require('../features/page-actions-start'),
	subteamStart = require('../features/sub-team/sub-team-start'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	plans = require('../models/plans'),
	JsonStorage = require('../models/json-storage'),
	TaskBuilder = require('../models/task-builder'),
	personalSignupStart = require('../features/signup/personal-signup-start'),
	SubscriptionAddInsModel = require('../models/subscription-add-ins-model'),
	ReceiptsModel = require('../models/receipts-model');

require('../widgets/linked-email-list-widget');
require('../widgets/add-sub-account-widget');
require('../widgets/sub-account-list-widget');
require('../widgets/add-linked-email-widget');
require('../widgets/domain-signup-widget');
require('../widgets/contact-link-widget');
require('../widgets/suggested-email-widget');
require('../widgets/dispatched-event-toggle-widget');
require('../widgets/dispatched-event-value-widget');
require('../widgets/account-invitation-widget');
require('../widgets/radio-checker-widget');
require('../widgets/receipts-widget');
require('../widgets/add-ins-widget');
require('../widgets/add-ins-purchase-widget');
require('../widgets/invoice-view-widget');
require('../widgets/microsoft-teams-authorisation-widget');
module.exports = function () {
	const browserStorage = getStorage(window, config.memoryLicenseStorage, config.memoryLicenseStorage),
		storage = new JsonStorage(browserStorage),
		navigatorShim = new NavigatorShim(),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes)),
		ajaxPromise = new AjaxPromise(navigatorShim),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationAWSStart(config, goldApi, navigatorShim, window, ajaxPromise, {reauthenticatorStorage: storage, storageName: 'account'}),
		cognito = config && config.cognito && cognitoStart(config, goldApi, authentication.subscriptionModel, authentication.authenticationModel, authentication.reauthenticator, navigatorShim),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		subteams = subteamStart(authentication, goldApi, s3Api, authentication.subscriptionModel),
		pageController = new AccountPageController(authentication.authenticationModel, authentication.subscriptionModel, navigatorShim, subteams.model, authentication.affiliateTeamIdentityProvider, {reauthenticator: authentication.reauthenticator}),
		taskBuilder = new TaskBuilder(goldApi, s3Api, navigatorShim, authentication.authenticationModel.getLicense),
		subscriptionAddInsModel = new SubscriptionAddInsModel(taskBuilder, authentication.subscriptionModel),
		receiptsModel = new ReceiptsModel(taskBuilder),
		components = Object.assign({
			cognito, pageController, subscriptionPlanModel, receiptsModel,
			subteamApi: subteams.api,
			subteamModel: subteams.model,
			navigatorModel: navigatorShim,
			subscriptionAddInsModel
		}, authentication);
	authentication.subscriptionModel.addEventListener('goldAccountInfo', accountInfo => {
		if (accountInfo && accountInfo.license) {
			navigatorShim.storeForSession('license', JSON.stringify(accountInfo.license));
		}
	});
	personalSignupStart(config, authentication.subscriptionModel, subscriptionPlanModel, authentication.authenticationModel, navigatorShim, s3Api, goldApi);
	pageActionsStart(components);
	window.components = components;
	subteams.initialiseWidgets();
	mmWidgets('[data-mm-role~="receipt-list"]').receiptsWidget(receiptsModel);
	mmWidgets('[data-mm-role~="add-in-list"]').addInsWidget(subscriptionAddInsModel);
	mmWidgets('[data-mm-role~="purchase-add-in"]').addInsPurchaseWidget({subscriptionAddInsModel, subscriptionModel: authentication.subscriptionModel});
	mmWidgets('[data-mm-role~="accountInvitations"]').accountInvitationWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-role~="linkedEmailList"]').linkedEmailListWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-role~="sub-account-list"]').subAccountListWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-role="add-linked-email"]').addLinkedEmailWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-role="add-sub-account"]').addSubAccountWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-sub-account-value]').dispatchedEventValueWidget(authentication.subscriptionModel, ['subAccountContext'], 'mm-sub-account-value');
	mmWidgets('[data-mm-sub-account-toggle]').dispatchedEventToggleWidget(authentication.subscriptionModel, ['subAccountContext'], 'data-mm-sub-account-toggle', 'event-value', 'event-toggle-class');
	mmWidgets('[data-mm-linked-email-value]').dispatchedEventValueWidget(authentication.subscriptionModel, ['linkedEmailNotification'], 'mm-linked-email-value');
	mmWidgets('[data-mm-linked-email-toggle]').dispatchedEventToggleWidget(authentication.subscriptionModel, ['linkedEmailNotification'], 'data-mm-linked-email-toggle', 'event-value', 'event-toggle-class');

	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);
	mmWidgets('#sectionNone').radioCheckerWidget(authentication.authenticationModel, 'not-authenticated');
	mmWidgets('#sectionSummary').radioCheckerWidget(authentication.authenticationModel, 'authenticatedProfile');
	mmWidgets('[data-mm-role~="microsoft-teams-authorisation"]').microsoftTeamsAuthorisationWidget(config, navigatorShim, authentication.authenticationModel);
	mmWidgets('[data-mm-role~="invoice-view"]').invoiceViewWidget(authentication.subscriptionModel);
	pageController.start();
};
